import { Check } from "lucide-react";
import HeroMockup from "@/components/sections/HeroMockup";

const BENEFITS = [
  {
    title: "Straightforward Pricing",
    desc: "One setup fee and a simple monthly plan.",
  },
  {
    title: "Handled For You",
    desc: "We take care of the setup, hosting, and technical details.",
  },
  {
    title: "Built for Business",
    desc: "Designed to look professional on phones, tablets, and computers.",
  },
];

const scrollTo = (id) => (e) => {
  const el = document.querySelector(id);
  if (el) {
    e.preventDefault();
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    history.replaceState(null, "", id);
  }
};

export const Hero = () => {
  return (
    <section
      id="hero"
      className="relative bg-goc-navy text-white overflow-hidden"
      data-testid="section-hero"
    >
      <div className="absolute inset-0 hero-dot-pattern opacity-100 pointer-events-none" />
      <div className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-goc-primary/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-14 md:pt-20 md:pb-28 lg:pt-24 lg:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          <div className="lg:col-span-6">
            <h1 className="text-4xl sm:text-5xl lg:text-[3.5rem] font-extrabold tracking-tight leading-[1.05] text-white">
              We Build Professional{" "}
              <span className="text-goc-primary">Websites</span> for{" "}
              <span className="text-goc-primary">Small Businesses</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-white/75 leading-relaxed max-w-xl">
              We create modern, mobile-friendly websites that help your business
              look professional and make it easier for customers to contact
              you. We handle the setup so you can focus on running your
              business.
            </p>

            <ul className="mt-8 space-y-3.5" aria-label="Key benefits">
              {BENEFITS.map((b) => (
                <li
                  key={b.title}
                  className="flex items-start gap-3"
                  data-testid={`hero-benefit-${b.title
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <span className="mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-goc-primary/15 text-goc-primary">
                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                  </span>
                  <span>
                    <span className="font-semibold text-white">{b.title}</span>
                    <span className="text-white/70"> — {b.desc}</span>
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#lead-form"
                onClick={scrollTo("#lead-form")}
                className="inline-flex items-center rounded-lg bg-goc-primary px-6 py-3.5 text-base font-semibold text-white hover:bg-goc-deep transition-colors shadow-sm shadow-goc-primary/30"
                data-testid="hero-cta-get-my-website"
              >
                Get My Website
              </a>
              <a
                href="#demos"
                onClick={scrollTo("#demos")}
                className="inline-flex items-center rounded-lg px-4 py-3.5 text-base font-semibold text-white/90 hover:text-white transition-colors"
                data-testid="hero-cta-see-website-examples"
              >
                See Website Examples
                <span className="ml-1" aria-hidden="true">
                  →
                </span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-6">
            <HeroMockup />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
